import lodash from 'lodash';

/**
 * This is a recursive function that extracts the values of a key from an object.
 * N.B.: the key should not contain any "." character.
 *
 * @param objects the objects to extract the values from
 * @param key the key that we want to extract the values of
 * @returns the array of values extracted from the input objects
 */
function getWithArraysIgnore(objects: any[], key: string): any[] {
  return objects.flatMap(object => {
    if (Array.isArray(object)) {
      return getWithArraysIgnore(object, key);
    }
    const value = lodash.get(object, key);
    if (value) {
      return Array.isArray(value) ? value : [value];
    }
    return [];
  });
}

/**
 * Returns the values of all the fields defined in the filters extracted from the document.
 * This function contains a replacement for `lodash.get` that explode the values of array fields.
 * For example, in case of a document like this:
 * {
 *   "key": [
 *     {
 *       "subKey": "value1"
 *     },
 *     {
 *       "subKey": "value2"
 *     }
 *   ]
 * }
 * A filter key = "key.subKey" will return ["value1", "value2"].
 *
 * @param path the field path to extract the values from
 * @param document the document to extract the values from
 * @returns the array of field values extracted from the document
 */
export function getDocumentFieldValues(path: string, document: any): any[] {
  const pathFields = path.split('.');
  let objects = [document];
  let index = 0;
  const length = pathFields.length;

  while (objects && objects.length > 0 && index < length) {
    const key = pathFields[index++];
    objects = getWithArraysIgnore(objects, key);
  }

  if (index && index === length) {
    return objects;
  }

  return [];
}
